import api from "../../services/api";

const path = "v1/mapa";

export const getMapContract = async ({ params = "" }) => {
  return await api.get(`${path}/contrato${params}`);
};

export const getMapsWithoutContract = async ({
  pageNumber,
  queryString = "",
}) => {
  return await api.get(
    `${path}/sem-contrato?${pageNumber ? `pageNumber=${pageNumber}` : ""}${
      queryString ? `&queryString=${queryString}` : ""
    }`
  );
};
